import React, { Fragment, Component } from 'react'
import PropTypes from 'prop-types'
import Button from '@material-ui/core/Button'
import Dialog from '../../components/IdentifiedDialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import withMobileDialog from '@material-ui/core/withMobileDialog'
import Input from '@material-ui/core/Input'
import InputLabel from '@material-ui/core/InputLabel'
import FormControl from '@material-ui/core/FormControl'
import { connect } from 'react-redux'
import { atcClassificationsActions, messageActions } from '../../actions'
import { withStyles } from '@material-ui/core/styles'
import CircularProgress from '@material-ui/core/CircularProgress'
import Typography from '@material-ui/core/Typography'
import { readOnly } from '../../utils/permissions'
import Checkbox from '@material-ui/core/Checkbox'
import FormControlLabel from '@material-ui/core/FormControlLabel'

const styles = theme => ({
  box: theme.mixins.gutters({
    paddingTop: 16,
    paddingBottom: 16,
    margin: 'auto',
    width: '80%',
    maxWidth: '400px',
    background: 'blue'
  }),
  errorMessage: {
    position: 'absolute',
    bottom: '-22px',
    left: 0
  },
  wrapperLoader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: '280px',
    width: '100%',
    height: '100%',
    minHeight: '200px'
  },
  formGroup: {
    padding: '12px 0'
  },
  root: {
    display: 'flex',
    minHeight: '100%',
    padding: '16px 0',
    boxSizing: 'border-box',
    flexDirection: 'column',
    background: '#fafafa'
  },
  formControl: {
    margin: '14px 0'
  }
})

class EditModal extends Component {
  handleSave = atcClassification => {
    const { onClose, addAtcClassification, editAtcClassification, changeMessage } = this.props
    if (atcClassification._id) {
      editAtcClassification(atcClassification).then(res => {
        changeMessage({ message: 'Alteração realizada com sucesso.' })
        onClose()
      })
    } else {
      addAtcClassification(atcClassification).then(res => {
        changeMessage({ message: 'Cadastro realizado com sucesso.' })
        onClose()
      })
    }
  }

  handleSubmit = (e, atcClassification) => {
    e.preventDefault()
    const { setAtcClassificationFormTouched } = this.props

    if ((this.props.atcClassificationFormErrors || {}).valid) {
      this.handleSave(atcClassification)
    } else {
      setAtcClassificationFormTouched()
    }
    return false
  }

  clearErrors = () => {
    this.setState({ formErrors: {} })
  }

  render() {
    const {
      fullScreen,
      onClose,
      open = false,
      classes,
      atcClassification,
      handleChangeAtcClassification,
      loadingAtcClassification,
      atcClassificationFormErrors,
      formTouched,
      token
    } = this.props

    const { handleSubmit, clearErrors } = this
    const isReadOnly = readOnly('classificacoesAtc', token)

    return (
      <div>
        <Dialog
          modalId={atcClassification._id ? 'classificacoes-atc-editar' : 'classificacoes-atc-nova'}
          modalParams={{ registro: atcClassification._id }}
          fullScreen={fullScreen}
          fullWidth
          open={open}
          onClose={onClose}
          className={classes.dialog}
        >
          {loadingAtcClassification ? (
            <div className={classes.wrapperLoader}>
              <CircularProgress />
            </div>
          ) : (
            <Fragment>
              <DialogTitle id={(atcClassification._id ? 'classificacoes-atc-editar' : 'classificacoes-atc-nova') + '-title'}>
                {isReadOnly ? (
                  'Classificacoes_atc'
                ) : (
                  <Fragment>
                    {atcClassification._id
                      ? 'Editar classificação ATC'
                      : 'Cadastrar classificação ATC'}
                  </Fragment>
                )}
              </DialogTitle>

              <DialogContent>
                <form
                  id={'atcClassification-form'}
                  noValidate
                  onSubmit={e => {
                    handleSubmit(e, atcClassification)
                  }}
                >
                  <FormControl
                    error={
                      !((atcClassificationFormErrors.fields || {})['codigo'] || {}).valid &&
                      formTouched
                    }
                    className={classes.formControl}
                    fullWidth
                  >
                    <InputLabel htmlFor="field-codigo">Código</InputLabel>
                    <Input
                      disabled={isReadOnly}
                      fullWidth
                      required={'required'}
                      type="text"
                      onChange={e => {
                        clearErrors()
                        handleChangeAtcClassification({
                          ...atcClassification,
                          codigo: e.target.value
                        })
                      }}
                      value={atcClassification.codigo}
                      autoFocus
                      id="field-codigo"
                    />
                    {!((atcClassificationFormErrors.fields || {})['codigo'] || {}).valid &&
                    formTouched ? (
                      <Typography className={classes.errorMessage} noWrap color={'error'}>
                        {((atcClassificationFormErrors.fields || {})['codigo'] || {}).errorMessage}
                      </Typography>
                    ) : null}
                  </FormControl>

                  <FormControl
                    error={
                      !((atcClassificationFormErrors.fields || {})['nome'] || {}).valid &&
                      formTouched
                    }
                    className={classes.formControl}
                    fullWidth
                  >
                    <InputLabel htmlFor="field-nome">Nome</InputLabel>
                    <Input
                      disabled={isReadOnly}
                      fullWidth
                      required={'required'}
                      type="text"
                      onChange={e => {
                        clearErrors()
                        handleChangeAtcClassification({
                          ...atcClassification,
                          nome: e.target.value
                        })
                      }}
                      value={atcClassification.nome}
                      id="field-nome"
                    />
                    {!((atcClassificationFormErrors.fields || {})['nome'] || {}).valid &&
                    formTouched ? (
                      <Typography className={classes.errorMessage} noWrap color={'error'}>
                        {((atcClassificationFormErrors.fields || {})['nome'] || {}).errorMessage}
                      </Typography>
                    ) : null}
                  </FormControl>

                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={!!atcClassification.atc}
                        onChange={e => {
                          clearErrors()
                          handleChangeAtcClassification({
                            ...atcClassification,
                            atc: !atcClassification.atc
                          })
                        }}
                        value={atcClassification.atc}
                        color="primary"
                      />
                    }
                    label={'ATC?'}
                  />
                </form>
              </DialogContent>
              <DialogActions>
                <Button onClick={onClose} color="default">
                  {isReadOnly ? 'Voltar' : 'Cancelar'}
                </Button>
                {!isReadOnly && (
                  <Button
                    type={'submit'}
                    form={'atcClassification-form'}
                    color="primary"
                    variant="raised"
                  >
                    Salvar
                  </Button>
                )}
              </DialogActions>
            </Fragment>
          )}
        </Dialog>
      </div>
    )
  }
}

EditModal.propTypes = {
  fullScreen: PropTypes.bool.isRequired
}

const mapStateToProps = state => {
  return {
    atcClassification: state.atcClassifications.atcClassification,
    loadingAtcClassification: state.atcClassifications.loadingAtcClassification,
    atcClassificationFormErrors: state.atcClassifications.atcClassificationFormErrors,
    formTouched: state.atcClassifications.atcClassificationFormTouched,
    token: state.auth.token
  }
}

const mapDispatchToProps = dispatch => {
  return {
    openModal: () => {
      dispatch(atcClassificationsActions.openModal())
    },
    closeModal: () => {
      dispatch(atcClassificationsActions.closeModal())
    },
    handleChangeAtcClassification: atcClassification => {
      dispatch(atcClassificationsActions.handleChangeAtcClassification(atcClassification))
    },
    addAtcClassification: atcClassification => {
      return dispatch(atcClassificationsActions.addAtcClassification(atcClassification))
    },
    editAtcClassification: atcClassification => {
      return dispatch(atcClassificationsActions.editAtcClassification(atcClassification))
    },
    setAtcClassificationFormTouched: atcClassification => {
      dispatch(atcClassificationsActions.setAtcClassificationFormTouched())
    },
    changeMessage: ({ message }) => {
      dispatch(messageActions.changeMessage({ message }))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withMobileDialog()(withStyles(styles)(EditModal)))



// WEBPACK FOOTER //
// ./src/containers/AtcClassifications/EditModal.js